import RoleEnum from './roleEnum';
import CommercialFileEnergyEtatEnum from './commercialFileEnergyEtatEnum';

class CommercialFileEnergyStatusEnum {

    static readonly BROUILLON = new CommercialFileEnergyStatusEnum('BROUILLON', 'BROUILLON', 'bruillon_badge', [], 'ENERGY', '#888888');
    static readonly BROUILLON_CF = new CommercialFileEnergyStatusEnum('BROUILLON_CF', 'BROUILLON_CF', 'bruillon_badge', [], 'ENERGY', '#494242');
    static readonly NRP = new CommercialFileEnergyStatusEnum('NRP', 'NRP', 'nrp_badge', [], 'ENERGY', '#ff17c5');
    static readonly NRP_CF = new CommercialFileEnergyStatusEnum('NRP_CF', 'NRP CF', 'nrp_badge', [], 'ENERGY', '#c2119a');
    static readonly ENGAGE = new CommercialFileEnergyStatusEnum('ENGAGE', 'ENGAGE', 'nrp_badge', [], 'ENERGY', '#35d745');
    static readonly RAPPEL = new CommercialFileEnergyStatusEnum('RAPPEL', 'RAPPEL', 'nrp_badge', [], 'ENERGY', '#eafd0e');
    static readonly RAPPEL_CF = new CommercialFileEnergyStatusEnum('RAPPEL_CF', 'RAPPEL CF', 'nrp_badge', [], 'ENERGY', '#c9b800');
    static readonly HORS_CIBLE = new CommercialFileEnergyStatusEnum('HORS_CIBLE', 'HORS_CIBLE', 'nrp_badge', [], 'ENERGY', '#c82b2b');
    static readonly HC_ARRET_ACTIVITE = new CommercialFileEnergyStatusEnum('HC_ARRET_ACTIVITE', 'HC - ARRÊT ACTIVITÉ', 'nrp_badge', [], 'ENERGY', '#8b1a1a');
    static readonly INJOIGNABLE = new CommercialFileEnergyStatusEnum('INJOIGNABLE', 'INJOIGNABLE', 'nrp_badge', [], 'ENERGY', '#fac540');
    static readonly INJOIGNABLE_CF = new CommercialFileEnergyStatusEnum('INJOIGNABLE_CF', 'INJOIGNABLE CF', 'nrp_badge', [], 'ENERGY', '#c79a1f');
    static readonly REFUS = new CommercialFileEnergyStatusEnum('REFUS', 'REFUS', 'nrp_badge', [], 'ENERGY', '#f1153f');
    static readonly RDV = new CommercialFileEnergyStatusEnum('RDV', 'RDV', 'nrp_badge', [], 'ENERGY', '#07ca22');
    static readonly RDV_CF = new CommercialFileEnergyStatusEnum('RDV_CF', 'RDV CF', 'nrp_badge', [], 'ENERGY', '#05881a');
    static readonly REGIE = new CommercialFileEnergyStatusEnum('REGIE', 'REGIE', 'nrp_badge', [], 'ENERGY', '#e7345d');
    static readonly ACCORD_CADRE = new CommercialFileEnergyStatusEnum('ACCORD_CADRE', 'ACCORD_CADRE', 'nrp_badge', [], 'ENERGY', '#ca070e');
    static readonly ACCORD_CADRE_CF = new CommercialFileEnergyStatusEnum('ACCORD_CADRE_CF', 'ACCORD CADRE CF', 'nrp_badge', [], 'ENERGY', '#96050a');
    static readonly LOCATAIRE = new CommercialFileEnergyStatusEnum('LOCATAIRE', 'LOCATAIRE', 'nrp_badge', [], 'ENERGY', '#ef585c');
    static readonly FACTURE_RECU = new CommercialFileEnergyStatusEnum('FACTURE_RECU', 'FACTURE_RECU', 'nrp_badge', [], 'ENERGY', '#3b8bff');
    static readonly ATTENTE_DE_FACTURE = new CommercialFileEnergyStatusEnum('ATTENTE_DE_FACTURE', 'ATTENTE_DE_FACTURE', 'nrp_badge', [], 'ENERGY', '#f37dd5');
    static readonly ATTENTE_FACTURE_CF = new CommercialFileEnergyStatusEnum('ATTENTE_FACTURE_CF', 'ATTENTE FACTURE CF', 'nrp_badge', [], 'ENERGY', '#c14fa4');
    static readonly PAS_INTERESSE = new CommercialFileEnergyStatusEnum('PAS_INTERESSE', 'PAS_INTERESSE', 'nrp_badge', [], 'ENERGY', '#92010f');
    static readonly CONCURENCE = new CommercialFileEnergyStatusEnum('CONCURENCE', 'CONCURENCE', 'nrp_badge', [], 'ENERGY', '#fd0013');
    static readonly PRO_EN_COURS = new CommercialFileEnergyStatusEnum('PRO_EN_COURS', 'PRO_EN_COURS', 'nrp_badge', [], 'ENERGY', '#1207ac');
    static readonly DEMANDE_DE_COTA = new CommercialFileEnergyStatusEnum('DEMANDE_DE_COTA', 'DEMANDE_DE_COTA', 'nrp_badge', [], 'ENERGY', '#0cb75e');
    static readonly COTA_MONO_EN_COURS = new CommercialFileEnergyStatusEnum('COTA_MONO_EN_COURS', 'COTA_MONO_EN_COURS', 'nrp_badge', [], 'ENERGY', '#1386a2');
    static readonly COTA_MULTISITE_EN_COURS = new CommercialFileEnergyStatusEnum('COTA_MULTISITE_EN_COURS', 'COTA_MULTISITE_EN_COURS', 'nrp_badge', [], 'ENERGY', '#a2134c');
    static readonly MULTI_PRO_EN_COURS = new CommercialFileEnergyStatusEnum('MULTI_PRO_EN_COURS', 'MULTI_PRO_EN_COURS', 'nrp_badge', [], 'ENERGY', '#8a0dac');
    static readonly SIGNE = new CommercialFileEnergyStatusEnum('SIGNE', 'SIGNE', 'nrp_badge', [], 'ENERGY', '#1ee5ff');
    static readonly SIGNE_CF = new CommercialFileEnergyStatusEnum('SIGNE_CF', 'SIGNE_CF', 'nrp_badge', [], 'ENERGY', '#07c1da');
    static readonly VALIDE_COTA_MONOSITE = new CommercialFileEnergyStatusEnum('VALIDE_COTA_MONOSITE', 'VALIDE_COTA_MONOSITE', 'nrp_badge', [], 'ENERGY', '#1386a2');
    static readonly VALIDE_PRO_MONOSITE = new CommercialFileEnergyStatusEnum('VALIDE_PRO_MONOSITE', 'VALIDE_PRO_MONOSITE', 'nrp_badge', [], 'ENERGY', '#8546ff');
    static readonly VALIDE_PRO_MULTISITE = new CommercialFileEnergyStatusEnum('VALIDE_PRO_MULTISITE', 'VALIDE_PRO_MULTISITE', 'nrp_badge', [], 'ENERGY', '#38d8ff');
    static readonly VALIDE_COTA_MULTISITE = new CommercialFileEnergyStatusEnum('VALIDE_COTA_MULTISITE', 'VALIDE_COTA_MULTISITE', 'nrp_badge', [], 'ENERGY', '#7a5ff1');
    static readonly INVALIDE = new CommercialFileEnergyStatusEnum('INVALIDE', 'INVALIDE', 'nrp_badge', [], 'ENERGY', '#4e4b4b');

    constructor(
        /**
         * The name of the instance; should be exactly the variable name,
         * for serializing/deserializing simplicity.
         */
        public readonly name: string,
        public readonly label: string,
        public readonly badge: string,
        public nextStatuses: CommercialFileEnergyStatusEnum[],
        public readonly type: string,
        public readonly color: string) {

        this.name = name;
        this.label = label;
        this.badge = badge;
        this.type = type;
        this.color = color;
        this.nextStatuses = nextStatuses;
    }

    static get values(): CommercialFileEnergyStatusEnum[] {
        return [
            this.NRP,
            this.NRP_CF,
            this.ENGAGE,
            this.RAPPEL,
            this.RAPPEL_CF,
            this.HORS_CIBLE,
            this.HC_ARRET_ACTIVITE,
            this.INJOIGNABLE,
            this.INJOIGNABLE_CF,
            this.REFUS,
            this.RDV,
            this.RDV_CF,
            this.REGIE,
            this.ACCORD_CADRE,
            this.ACCORD_CADRE_CF,
            this.LOCATAIRE,
            this.FACTURE_RECU,
            this.ATTENTE_DE_FACTURE,
            this.ATTENTE_FACTURE_CF,
            this.PAS_INTERESSE,
            this.CONCURENCE,
            this.PRO_EN_COURS,
            this.DEMANDE_DE_COTA,
            this.COTA_MONO_EN_COURS,
            this.COTA_MULTISITE_EN_COURS,
            this.MULTI_PRO_EN_COURS,
            this.SIGNE,
            this.SIGNE_CF,
            this.VALIDE_COTA_MONOSITE,
            this.VALIDE_PRO_MONOSITE,
            this.VALIDE_PRO_MULTISITE,
            this.VALIDE_COTA_MULTISITE,
            this.INVALIDE,
            this.BROUILLON_CF
        ];
    }

    static getListLabes(): CommercialFileEnergyStatusEnum[] {
        return [
            this.BROUILLON,
            this.NRP,
            this.NRP_CF,
            this.ENGAGE,
            this.RAPPEL,
            this.RAPPEL_CF,
            this.HORS_CIBLE,
            this.HC_ARRET_ACTIVITE,
            this.INJOIGNABLE,
            this.INJOIGNABLE_CF,
            this.REFUS,
            this.RDV,
            this.RDV_CF,
            this.REGIE,
            this.ACCORD_CADRE,
            this.ACCORD_CADRE_CF,
            this.LOCATAIRE,
            this.FACTURE_RECU,
            this.ATTENTE_DE_FACTURE,
            this.ATTENTE_FACTURE_CF,
            this.PAS_INTERESSE,
            this.CONCURENCE,
            this.PRO_EN_COURS,
            this.DEMANDE_DE_COTA,
            this.COTA_MONO_EN_COURS,
            this.COTA_MULTISITE_EN_COURS,
            this.MULTI_PRO_EN_COURS,
            this.SIGNE,
            this.SIGNE_CF,
            this.VALIDE_COTA_MONOSITE,
            this.VALIDE_PRO_MONOSITE,
            this.VALIDE_PRO_MULTISITE ,
            this.VALIDE_COTA_MULTISITE,
            this.INVALIDE,
            this.BROUILLON_CF
        ];
    }

    /**
     * Converts a string to its corresponding Status instance.
     *
     * @param string the string to convert to Status
     * @throws RangeError, if a string that has no corresponding Status value was passed.
     * @returns the matching Status
     */
    static fromString(string: string): CommercialFileEnergyStatusEnum {
        // Works assuming the name property of the status is identical to the variable's name.
        // Alternatively, you can search the .values array
        const value = (this as any)[string];
        if (value) {
            return value;
        }
        return null;
        //throw new RangeError(`Illegal argument passed to fromString(): $ {string} does not correspond to any instance of the enum ${(this as any).prototype.constructor.name}`);
    }

    /**
     * Statuts « positifs » : sélection par défaut du filtre des listes énergie.
     * Une seule définition, utilisée par la liste et par la recherche avancée.
     */
    static getPositiveStatusNames(): string[] {
        return ['BROUILLON', 'NRP', 'NRP_CF', 'ENGAGE', 'RAPPEL', 'RAPPEL_CF', 'RDV', 'RDV_CF', 'FACTURE_RECU',
            'ATTENTE_DE_FACTURE', 'ATTENTE_FACTURE_CF', 'PRO_EN_COURS', 'DEMANDE_DE_COTA', 'COTA_MONO_EN_COURS',
            'COTA_MULTISITE_EN_COURS', 'MULTI_PRO_EN_COURS'];
    }

    /**
     * Remet à zéro les enchaînements avant de recalculer le workflow d'une étape.
     */
    static initWorkFlow() {
        CommercialFileEnergyStatusEnum.getListLabes()
            .forEach(status => status.nextStatuses = []);
    }

    /**
     * Recalcule les qualifications proposées, pour l'étape (état de la fiche) passée en paramètre.
     *
     * Règle unique : à l'intérieur d'une étape, toutes les qualifications communiquent entre
     * elles — depuis n'importe laquelle on peut choisir n'importe quelle autre de la même étape.
     * Le passage d'une étape à la suivante est décidé par le backend à partir de la qualification
     * choisie (RDV -> CLIENT, FACTURE_RECU -> CLIENT_EN_ACQUISITION, SIGNE -> CLIENT_ACQUIS,
     * SIGNE_CF -> VALIDATION, VALIDE_* -> CLIENT_A_FIDELISER, INVALIDE -> étape de travail).
     */
    static updateWorkFlow(fileStatus: string) {
        CommercialFileEnergyStatusEnum.initWorkFlow();

        const etapeStatuses = CommercialFileEnergyStatusEnum.getListStatusByEtat(fileStatus) || [];
        etapeStatuses.forEach(status => status.nextStatuses = etapeStatuses);

        // La qualification qui a fait basculer la fiche sur cette étape n'appartient pas toujours
        // à la liste de l'étape ; elle doit malgré tout ouvrir la liste complète.
        CommercialFileEnergyStatusEnum.getEntryStatusesByEtat(fileStatus)
            .forEach(status => status.nextStatuses = etapeStatuses);
    }

    /**
     * Qualifications par lesquelles une fiche entre sur une étape sans faire partie de la liste
     * de cette étape. BROUILLON_CF, remplacé par RAPPEL_CF, n'est plus proposé nulle part mais
     * reste listé ici : les fiches historiques non reprises doivent rester requalifiables.
     */
    static getEntryStatusesByEtat(etat: string): CommercialFileEnergyStatusEnum[] {
        if (CommercialFileEnergyEtatEnum.CLIENT_EN_ACQUISITION.name === etat) {
            return [CommercialFileEnergyStatusEnum.INVALIDE];
        }
        if (CommercialFileEnergyEtatEnum.CLIENT_A_FIDELISER.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MONOSITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MONOSITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MULTISITE,
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MULTISITE,
                CommercialFileEnergyStatusEnum.INVALIDE,
                CommercialFileEnergyStatusEnum.BROUILLON_CF
            ];
        }
        return [];
    }

    static getListStatusByEtat(etat: string) {
        if (CommercialFileEnergyEtatEnum.PROSPECT.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.BROUILLON,
                CommercialFileEnergyStatusEnum.NRP,
                CommercialFileEnergyStatusEnum.ENGAGE,
                CommercialFileEnergyStatusEnum.RAPPEL,
                CommercialFileEnergyStatusEnum.HORS_CIBLE,
                CommercialFileEnergyStatusEnum.INJOIGNABLE,
                CommercialFileEnergyStatusEnum.REFUS,
                CommercialFileEnergyStatusEnum.RDV,
                CommercialFileEnergyStatusEnum.REGIE,
                CommercialFileEnergyStatusEnum.ACCORD_CADRE,
                CommercialFileEnergyStatusEnum.LOCATAIRE
            ];
        }
        if (CommercialFileEnergyEtatEnum.CLIENT.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.RDV,
                CommercialFileEnergyStatusEnum.FACTURE_RECU,
                CommercialFileEnergyStatusEnum.ATTENTE_DE_FACTURE,
                CommercialFileEnergyStatusEnum.NRP,
                CommercialFileEnergyStatusEnum.ENGAGE,
                CommercialFileEnergyStatusEnum.RAPPEL,
                CommercialFileEnergyStatusEnum.HORS_CIBLE,
                CommercialFileEnergyStatusEnum.REFUS,
                CommercialFileEnergyStatusEnum.INJOIGNABLE,
                CommercialFileEnergyStatusEnum.REGIE,
                CommercialFileEnergyStatusEnum.ACCORD_CADRE,
                CommercialFileEnergyStatusEnum.LOCATAIRE
            ];
        }
        if (CommercialFileEnergyEtatEnum.CLIENT_EN_ACQUISITION.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.FACTURE_RECU,
                CommercialFileEnergyStatusEnum.ENGAGE,
                CommercialFileEnergyStatusEnum.PAS_INTERESSE,
                CommercialFileEnergyStatusEnum.CONCURENCE,
                CommercialFileEnergyStatusEnum.PRO_EN_COURS,
                CommercialFileEnergyStatusEnum.DEMANDE_DE_COTA,
                CommercialFileEnergyStatusEnum.COTA_MONO_EN_COURS,
                CommercialFileEnergyStatusEnum.COTA_MULTISITE_EN_COURS,
                CommercialFileEnergyStatusEnum.MULTI_PRO_EN_COURS,
                CommercialFileEnergyStatusEnum.SIGNE
            ];
        }
        if (CommercialFileEnergyEtatEnum.CLIENT_ACQUIS.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.SIGNE,
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MULTISITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MULTISITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MONOSITE,
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MONOSITE,
                CommercialFileEnergyStatusEnum.INVALIDE
            ];
        }
        if (CommercialFileEnergyEtatEnum.CLIENT_A_FIDELISER.name === etat) {
            // L'étape fidélisation a ses propres qualifications, distinctes de celles des étapes
            // amont : RDV, RAPPEL, NRP, INJOIGNABLE, ACCORD CADRE et ATTENTE DE FACTURE.
            return [
                CommercialFileEnergyStatusEnum.RDV_CF,
                CommercialFileEnergyStatusEnum.RAPPEL_CF,
                CommercialFileEnergyStatusEnum.NRP_CF,
                CommercialFileEnergyStatusEnum.INJOIGNABLE_CF,
                CommercialFileEnergyStatusEnum.ACCORD_CADRE_CF,
                CommercialFileEnergyStatusEnum.ATTENTE_FACTURE_CF,
                CommercialFileEnergyStatusEnum.FACTURE_RECU,
                CommercialFileEnergyStatusEnum.ENGAGE,
                CommercialFileEnergyStatusEnum.PAS_INTERESSE,
                CommercialFileEnergyStatusEnum.CONCURENCE,
                CommercialFileEnergyStatusEnum.PRO_EN_COURS,
                CommercialFileEnergyStatusEnum.DEMANDE_DE_COTA,
                CommercialFileEnergyStatusEnum.COTA_MONO_EN_COURS,
                CommercialFileEnergyStatusEnum.COTA_MULTISITE_EN_COURS,
                CommercialFileEnergyStatusEnum.MULTI_PRO_EN_COURS,
                CommercialFileEnergyStatusEnum.SIGNE_CF,
                CommercialFileEnergyStatusEnum.HC_ARRET_ACTIVITE
            ];
        }
        if (CommercialFileEnergyEtatEnum.HORS_CIBLE.name === etat) {
            // Aucune qualification ne place une fiche sur cette étape (seuls l'import Excel et les
            // données historiques le font) : on la traite comme un prospect à retravailler.
            return CommercialFileEnergyStatusEnum.getListStatusByEtat(CommercialFileEnergyEtatEnum.PROSPECT.name);
        }
        if (CommercialFileEnergyEtatEnum.VALIDATION.name === etat) {
            return [
                CommercialFileEnergyStatusEnum.SIGNE_CF,
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MONOSITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MONOSITE,
                CommercialFileEnergyStatusEnum.VALIDE_PRO_MULTISITE,
                CommercialFileEnergyStatusEnum.VALIDE_COTA_MULTISITE,
                CommercialFileEnergyStatusEnum.INVALIDE
            ];
        }
    }
    /**
     * Called when converting the Enum value to a string using JSON.Stringify.
     * Compare to the fromString() method, which deserializes the object.
     */
    public getName(): string {
        return this.name;
    }

    public getLabel(): string {
        return this.label;
    }

    public getNextStatuses(): CommercialFileEnergyStatusEnum[] {
        return this.nextStatuses;
    }

    public getBadge(): string {
        return this.badge;
    }
}

export default CommercialFileEnergyStatusEnum;
